// extracted by mini-css-extract-plugin
export default {"wrapper":"mediaItemAudio_wrapper__S8uSH","container":"mediaItemAudio_container__KtLRJ","audiomessage":"mediaItemAudio_audiomessage__91xpp"};